(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 56518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(8252);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 8252:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 7842:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(54293),
    now = __webpack_require__(78950),
    toNumber = __webpack_require__(39866);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 82553:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(8932),
    isObjectLike = __webpack_require__(55183);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 78950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(88723);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 39866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(56518),
    isObject = __webpack_require__(54293),
    isSymbol = __webpack_require__(82553);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(90543);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20150);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


const baseTitle = "SSO Opiquad";
const DocumentTitle = (param)=>{
    let { title =null  } = param;
    const t = title ? "".concat(title, " | ").concat(baseTitle) : baseTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
            children: t
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DocumentTitle);


/***/ }),

/***/ 78716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _DocumentTitle__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _DocumentTitle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65432);



/***/ }),

/***/ 37295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86604);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66013);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27280);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ErrorFeedback_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9860);
/* harmony import */ var _ErrorFeedback_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_ErrorFeedback_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28757);






const ErrorFeedback = (param)=>{
    let { error , asAlert =false  } = param;
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("error-feedback");
    const isValidation = error.graphQLErrors.some((err)=>{
        var _err_extensions;
        return ((_err_extensions = err.extensions) === null || _err_extensions === void 0 ? void 0 : _err_extensions.category) === "validation";
    });
    const messageBag = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isValidation) {
            return error.message;
        }
        let messages = [];
        error.graphQLErrors.forEach((err)=>{
            var _err_extensions;
            const validation = (_err_extensions = err.extensions) === null || _err_extensions === void 0 ? void 0 : _err_extensions.validation;
            if (validation) {
                const fieldMsg = Object.values(validation);
                messages = [
                    ...messages,
                    ...fieldMsg.flat()
                ];
            }
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Text */ .Z.Text, {
                    children: t("errors")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    children: messages.map((msg, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: msg
                        }, index))
                })
            ]
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidation
    ]);
    return !asAlert ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Text */ .Z.Text, {
        children: messageBag
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        type: "warning",
        message: messageBag,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_ErrorFeedback_module_scss__WEBPACK_IMPORTED_MODULE_6___default().Alert), {
            [(_ErrorFeedback_module_scss__WEBPACK_IMPORTED_MODULE_6___default().General)]: !isValidation
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorFeedback);


/***/ }),

/***/ 17987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _ErrorFeedback__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _ErrorFeedback__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37295);



/***/ }),

/***/ 90543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(36734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(51776);
// EXTERNAL MODULE: ./src/components/document-title/index.tsx
var document_title = __webpack_require__(78716);
// EXTERNAL MODULE: ./src/graphql/login.ts
var graphql_login = __webpack_require__(32572);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(35408);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(30791);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(93962);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(27280);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(7842);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/rc-util/es/omit.js
var omit = __webpack_require__(68371);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(68081);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/reactNode.js
var reactNode = __webpack_require__(45203);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/type.js
var type = __webpack_require__(40747);
// EXTERNAL MODULE: ./node_modules/@ant-design/cssinjs/es/index.js + 19 modules
var es = __webpack_require__(66886);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/genComponentStyleHook.js
var genComponentStyleHook = __webpack_require__(15470);
// EXTERNAL MODULE: ./node_modules/antd/es/theme/util/statistic.js
var statistic = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/antd/es/style/index.js
var style = __webpack_require__(6915);
;// CONCATENATED MODULE: ./node_modules/antd/es/spin/style/index.js





var antSpinMove = new es/* Keyframes */.E4('antSpinMove', {
  to: {
    opacity: 1
  }
});
var antRotate = new es/* Keyframes */.E4('antRotate', {
  to: {
    transform: 'rotate(405deg)'
  }
});
var genSpinStyle = function genSpinStyle(token) {
  var _sm, _lg, _ref, _nestedLoading, _extends2;
  return (0,defineProperty/* default */.Z)({}, "" + token.componentCls, (0,esm_extends/* default */.Z)((0,esm_extends/* default */.Z)({}, (0,style/* resetComponent */.Wf)(token)), (_extends2 = {
    position: 'absolute',
    display: 'none',
    color: token.colorPrimary,
    textAlign: 'center',
    verticalAlign: 'middle',
    opacity: 0,
    transition: "transform " + token.motionDurationSlow + " " + token.motionEaseInOutCirc,
    '&-spinning': {
      position: 'static',
      display: 'inline-block',
      opacity: 1
    },
    '&-nested-loading': (_nestedLoading = {
      position: 'relative'
    }, (0,defineProperty/* default */.Z)(_nestedLoading, "> div > " + token.componentCls, (_ref = {
      position: 'absolute',
      top: 0,
      insetInlineStart: 0,
      zIndex: 4,
      display: 'block',
      width: '100%',
      height: '100%',
      maxHeight: token.contentHeight
    }, (0,defineProperty/* default */.Z)(_ref, token.componentCls + "-dot", {
      position: 'absolute',
      top: '50%',
      insetInlineStart: '50%',
      margin: -token.spinDotSize / 2
    }), (0,defineProperty/* default */.Z)(_ref, token.componentCls + "-text", {
      position: 'absolute',
      top: '50%',
      width: '100%',
      paddingTop: (token.spinDotSize - token.fontSize) / 2 + 2,
      textShadow: "0 1px 2px " + token.colorBgContainer // FIXME: shadow
    }), (0,defineProperty/* default */.Z)(_ref, "&" + token.componentCls + "-show-text " + token.componentCls + "-dot", {
      marginTop: -(token.spinDotSize / 2) - 10
    }), (0,defineProperty/* default */.Z)(_ref, '&-sm', (_sm = {}, (0,defineProperty/* default */.Z)(_sm, token.componentCls + "-dot", {
      margin: -token.spinDotSizeSM / 2
    }), (0,defineProperty/* default */.Z)(_sm, token.componentCls + "-text", {
      paddingTop: (token.spinDotSizeSM - token.fontSize) / 2 + 2
    }), (0,defineProperty/* default */.Z)(_sm, "&" + token.componentCls + "-show-text " + token.componentCls + "-dot", {
      marginTop: -(token.spinDotSizeSM / 2) - 10
    }), _sm)), (0,defineProperty/* default */.Z)(_ref, '&-lg', (_lg = {}, (0,defineProperty/* default */.Z)(_lg, token.componentCls + "-dot", {
      margin: -(token.spinDotSizeLG / 2)
    }), (0,defineProperty/* default */.Z)(_lg, token.componentCls + "-text", {
      paddingTop: (token.spinDotSizeLG - token.fontSize) / 2 + 2
    }), (0,defineProperty/* default */.Z)(_lg, "&" + token.componentCls + "-show-text " + token.componentCls + "-dot", {
      marginTop: -(token.spinDotSizeLG / 2) - 10
    }), _lg)), _ref)), (0,defineProperty/* default */.Z)(_nestedLoading, token.componentCls + "-container", {
      position: 'relative',
      transition: "opacity " + token.motionDurationSlow,
      '&::after': {
        position: 'absolute',
        top: 0,
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        zIndex: 10,
        width: '100%',
        height: '100%',
        background: token.colorBgContainer,
        opacity: 0,
        transition: "all " + token.motionDurationSlow,
        content: '""',
        pointerEvents: 'none'
      }
    }), (0,defineProperty/* default */.Z)(_nestedLoading, token.componentCls + "-blur", (0,defineProperty/* default */.Z)({
      clear: 'both',
      opacity: 0.5,
      userSelect: 'none',
      pointerEvents: 'none'
    }, "&::after", {
      opacity: 0.4,
      pointerEvents: 'auto'
    })), _nestedLoading)
  }, (0,defineProperty/* default */.Z)(_extends2, "&-tip", {
    color: token.spinDotDefault
  }), (0,defineProperty/* default */.Z)(_extends2, token.componentCls + "-dot", {
    position: 'relative',
    display: 'inline-block',
    fontSize: token.spinDotSize,
    width: '1em',
    height: '1em',
    '&-item': {
      position: 'absolute',
      display: 'block',
      width: (token.spinDotSize - token.marginXXS / 2) / 2,
      height: (token.spinDotSize - token.marginXXS / 2) / 2,
      backgroundColor: token.colorPrimary,
      borderRadius: '100%',
      transform: 'scale(0.75)',
      transformOrigin: '50% 50%',
      opacity: 0.3,
      animationName: antSpinMove,
      animationDuration: '1s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
      animationDirection: 'alternate',
      '&:nth-child(1)': {
        top: 0,
        insetInlineStart: 0
      },
      '&:nth-child(2)': {
        top: 0,
        insetInlineEnd: 0,
        animationDelay: '0.4s'
      },
      '&:nth-child(3)': {
        insetInlineEnd: 0,
        bottom: 0,
        animationDelay: '0.8s'
      },
      '&:nth-child(4)': {
        bottom: 0,
        insetInlineStart: 0,
        animationDelay: '1.2s'
      }
    },
    '&-spin': {
      transform: 'rotate(45deg)',
      animationName: antRotate,
      animationDuration: '1.2s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear'
    }
  }), (0,defineProperty/* default */.Z)(_extends2, "&-sm " + token.componentCls + "-dot", {
    fontSize: token.spinDotSizeSM,
    i: {
      width: (token.spinDotSizeSM - token.marginXXS / 2) / 2,
      height: (token.spinDotSizeSM - token.marginXXS / 2) / 2
    }
  }), (0,defineProperty/* default */.Z)(_extends2, "&-lg " + token.componentCls + "-dot", {
    fontSize: token.spinDotSizeLG,
    i: {
      width: (token.spinDotSizeLG - token.marginXXS) / 2,
      height: (token.spinDotSizeLG - token.marginXXS) / 2
    }
  }), (0,defineProperty/* default */.Z)(_extends2, "&" + token.componentCls + "-show-text " + token.componentCls + "-text", {
    display: 'block'
  }), _extends2)));
};
// ============================== Export ==============================
/* harmony default export */ var spin_style = ((0,genComponentStyleHook/* default */.Z)('Spin', function (token) {
  var spinToken = (0,statistic/* merge */.TS)(token, {
    spinDotDefault: token.colorTextDescription,
    spinDotSize: token.controlHeightLG / 2,
    spinDotSizeSM: token.controlHeightLG * 0.35,
    spinDotSizeLG: token.controlHeight
  });
  return [genSpinStyle(spinToken)];
}, {
  contentHeight: 400
}));
;// CONCATENATED MODULE: ./node_modules/antd/es/spin/index.js



var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








var SpinSizes = (0,type/* tuple */.b)('small', 'default', 'large');
// Render indicator
var defaultIndicator = null;
function renderIndicator(prefixCls, props) {
  var indicator = props.indicator;
  var dotClassName = prefixCls + "-dot";
  // should not be render default indicator when indicator value is null
  if (indicator === null) {
    return null;
  }
  if ((0,reactNode/* isValidElement */.l$)(indicator)) {
    return (0,reactNode/* cloneElement */.Tm)(indicator, {
      className: classnames_default()(indicator.props.className, dotClassName)
    });
  }
  if ((0,reactNode/* isValidElement */.l$)(defaultIndicator)) {
    return (0,reactNode/* cloneElement */.Tm)(defaultIndicator, {
      className: classnames_default()(defaultIndicator.props.className, dotClassName)
    });
  }
  return /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(dotClassName, prefixCls + "-dot-spin")
  }, /*#__PURE__*/react.createElement("i", {
    className: prefixCls + "-dot-item"
  }), /*#__PURE__*/react.createElement("i", {
    className: prefixCls + "-dot-item"
  }), /*#__PURE__*/react.createElement("i", {
    className: prefixCls + "-dot-item"
  }), /*#__PURE__*/react.createElement("i", {
    className: prefixCls + "-dot-item"
  }));
}
function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !isNaN(Number(delay));
}
var Spin = function Spin(props) {
  var prefixCls = props.spinPrefixCls,
    _props$spinning = props.spinning,
    customSpinning = _props$spinning === void 0 ? true : _props$spinning,
    delay = props.delay,
    className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 'default' : _props$size,
    tip = props.tip,
    wrapperClassName = props.wrapperClassName,
    style = props.style,
    children = props.children,
    hashId = props.hashId,
    restProps = __rest(props, ["spinPrefixCls", "spinning", "delay", "className", "size", "tip", "wrapperClassName", "style", "children", "hashId"]);
  var _React$useState = react.useState(function () {
      return customSpinning && !shouldDelay(customSpinning, delay);
    }),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    spinning = _React$useState2[0],
    setSpinning = _React$useState2[1];
  react.useEffect(function () {
    var updateSpinning = debounce_default()(function () {
      setSpinning(customSpinning);
    }, delay);
    updateSpinning();
    return function () {
      var _a;
      (_a = updateSpinning === null || updateSpinning === void 0 ? void 0 : updateSpinning.cancel) === null || _a === void 0 ? void 0 : _a.call(updateSpinning);
    };
  }, [delay, customSpinning]);
  var isNestedPattern = function isNestedPattern() {
    return typeof children !== 'undefined';
  };
  var renderSpin = function renderSpin(_ref) {
    var _classNames;
    var direction = _ref.direction;
    var spinClassName = classnames_default()(prefixCls, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, prefixCls + "-sm", size === 'small'), (0,defineProperty/* default */.Z)(_classNames, prefixCls + "-lg", size === 'large'), (0,defineProperty/* default */.Z)(_classNames, prefixCls + "-spinning", spinning), (0,defineProperty/* default */.Z)(_classNames, prefixCls + "-show-text", !!tip), (0,defineProperty/* default */.Z)(_classNames, prefixCls + "-rtl", direction === 'rtl'), _classNames), className, hashId);
    // fix https://fb.me/react-unknown-prop
    var divProps = (0,omit/* default */.Z)(restProps, ['indicator', 'prefixCls']);
    var spinElement = /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, divProps, {
      style: style,
      className: spinClassName,
      "aria-live": "polite",
      "aria-busy": spinning
    }), renderIndicator(prefixCls, props), tip ? /*#__PURE__*/react.createElement("div", {
      className: prefixCls + "-text"
    }, tip) : null);
    if (isNestedPattern()) {
      var containerClassName = classnames_default()(prefixCls + "-container", (0,defineProperty/* default */.Z)({}, prefixCls + "-blur", spinning));
      return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, divProps, {
        className: classnames_default()(prefixCls + "-nested-loading", wrapperClassName, hashId)
      }), spinning && /*#__PURE__*/react.createElement("div", {
        key: "loading"
      }, spinElement), /*#__PURE__*/react.createElement("div", {
        className: containerClassName,
        key: "container"
      }, children));
    }
    return spinElement;
  };
  return /*#__PURE__*/react.createElement(context/* ConfigConsumer */.C, null, renderSpin);
};
var SpinFC = function SpinFC(props) {
  var customizePrefixCls = props.prefixCls;
  var _React$useContext = react.useContext(context/* ConfigContext */.E_),
    getPrefixCls = _React$useContext.getPrefixCls;
  var spinPrefixCls = getPrefixCls('spin', customizePrefixCls);
  var _useStyle = spin_style(spinPrefixCls),
    _useStyle2 = (0,slicedToArray/* default */.Z)(_useStyle, 2),
    wrapSSR = _useStyle2[0],
    hashId = _useStyle2[1];
  var spinClassProps = (0,esm_extends/* default */.Z)((0,esm_extends/* default */.Z)({}, props), {
    spinPrefixCls: spinPrefixCls,
    hashId: hashId
  });
  return wrapSSR( /*#__PURE__*/react.createElement(Spin, (0,esm_extends/* default */.Z)({}, spinClassProps)));
};
SpinFC.setDefaultIndicator = function (indicator) {
  defaultIndicator = indicator;
};
if (false) {}
/* harmony default export */ var spin = (SpinFC);
// EXTERNAL MODULE: ./src/components/loader/Loader.module.scss
var Loader_module = __webpack_require__(28719);
var Loader_module_default = /*#__PURE__*/__webpack_require__.n(Loader_module);
;// CONCATENATED MODULE: ./src/components/loader/Loader.tsx





const Loader = (param)=>{
    let { fullscreen =false , className =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((Loader_module_default()).Wrapper, className, {
            [(Loader_module_default()).Fullscreen]: fullscreen
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin, {})
    });
};
/* harmony default export */ var loader_Loader = (Loader);

;// CONCATENATED MODULE: ./src/components/loader/index.tsx


// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 20 modules
var es_form = __webpack_require__(6860);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 7 modules
var input = __webpack_require__(96342);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(74592);
// EXTERNAL MODULE: ./src/components/error-feedback/index.tsx
var error_feedback = __webpack_require__(17987);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(56562);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/lib/redirectToClient.ts
const redirectToClient = (redirect, token)=>{
    window.location.href = "".concat(redirect, "?access_token=").concat(token);
};
/* harmony default export */ var lib_redirectToClient = (redirectToClient);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(33906);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(9369);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(5218);
;// CONCATENATED MODULE: ./src/lib/setAccessTokenCookie.ts


const setAccessTokenCookie = (token, expires_in)=>{
    (0,lib.setCookie)("access_token", token, {
        path: "/",
        expires: dayjs_min_default()().add(expires_in, "seconds").toDate(),
        secure: true
    });
};
/* harmony default export */ var lib_setAccessTokenCookie = (setAccessTokenCookie);

;// CONCATENATED MODULE: ./src/hooks/useAccessTokenCookie.ts


const useAccessTokenCookie = ()=>{
    return (token, expires_in)=>{
        lib_setAccessTokenCookie(token, expires_in);
        router_default().push("/profile");
    };
};

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(6829);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(28757);
;// CONCATENATED MODULE: ./src/components/login/Login.tsx











const Login = (param)=>{
    let { onLoginCompleted  } = param;
    const router = (0,next_router.useRouter)();
    const [form] = es_form/* default.useForm */.Z.useForm();
    const { t  } = (0,useTranslation/* default */.Z)("login");
    const emailInput = (0,react.useRef)(null);
    const setAccessTokenCookie = useAccessTokenCookie();
    const [login, { loading , error  }] = (0,useMutation/* useMutation */.D)(graphql_login/* LOGIN */.ym, {
        onError: ()=>{},
        onCompleted: (res)=>{
            form.resetFields();
            if (res.login.__typename === "LoginSuccess") {
                const { redirect , tokens  } = res.login;
                if (redirect) {
                    lib_redirectToClient(redirect, tokens.access_token);
                } else {
                    setAccessTokenCookie(tokens.access_token, tokens.expires_in);
                }
            } else {
                const { qr_code , token  } = res.login;
                onLoginCompleted(token, qr_code);
            }
        }
    });
    const handleSubmitLogin = (values)=>{
        login({
            variables: values
        });
    };
    (0,react.useEffect)(()=>{
        if (emailInput.current) {
            emailInput.current.focus();
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error_feedback/* default */.Z, {
                asAlert: true,
                error: error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
                form: form,
                layout: "vertical",
                autoComplete: "off",
                onFinish: handleSubmitLogin,
                initialValues: {
                    client: router.query.client || "auth"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        name: "email",
                        label: "Email",
                        rules: [
                            {
                                required: true,
                                message: t("rules:required")
                            },
                            {
                                type: "email",
                                message: t("rules:email")
                            }
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                            ref: emailInput,
                            size: "large"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        name: "password",
                        label: "Password",
                        rules: [
                            {
                                required: true,
                                message: t("rules:required")
                            }
                        ],
                        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            passHref: true,
                            href: "/password/recovery",
                            children: t("password-dimenticata")
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default.Password */.Z.Password, {
                            size: "large"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        name: "client",
                        hidden: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                        block: true,
                        size: "large",
                        type: "primary",
                        htmlType: "submit",
                        loading: loading,
                        children: "Login"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var login_Login = (Login);

// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 22 modules
var typography = __webpack_require__(86604);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(67832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/otp-input/single-otp-input/SingleOTPInput.module.scss
var SingleOTPInput_module = __webpack_require__(70221);
var SingleOTPInput_module_default = /*#__PURE__*/__webpack_require__.n(SingleOTPInput_module);
;// CONCATENATED MODULE: ./src/components/otp-input/single-otp-input/SingleOTPInput.tsx



function SingleOTPInputComponent(param) {
    let { focus , ...rest } = param;
    const inputRef = (0,react.useRef)(null);
    (0,react.useLayoutEffect)(()=>{
        if (inputRef.current && focus) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [
        focus
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
        ...rest,
        type: "number",
        ref: inputRef,
        className: (SingleOTPInput_module_default()).Input
    });
}
const SingleOTPInput = /*#__PURE__*/ (0,react.memo)(SingleOTPInputComponent);
/* harmony default export */ var single_otp_input_SingleOTPInput = (SingleOTPInput);

;// CONCATENATED MODULE: ./src/components/otp-input/single-otp-input/index.tsx


// EXTERNAL MODULE: ./src/components/otp-input/OTPInput.module.scss
var OTPInput_module = __webpack_require__(35209);
var OTPInput_module_default = /*#__PURE__*/__webpack_require__.n(OTPInput_module);
;// CONCATENATED MODULE: ./src/components/otp-input/OTPInput.tsx




const OTPInput = (param)=>{
    let { length , onChange  } = param;
    const [activeInput, setActiveInput] = (0,react.useState)(0);
    const [otpValues, setOTPValues] = (0,react.useState)(Array(length).fill(""));
    (0,react.useEffect)(()=>{
        onChange && onChange(otpValues.join(""));
    }, [
        otpValues,
        onChange
    ]);
    // Helper to return value with the right type: 'text' or 'number'
    const getRightValue = (0,react.useCallback)((str)=>Number(str) >= 0 ? str : "", []);
    // Change OTP value at focussing input
    const changeCodeAtFocus = (0,react.useCallback)((str)=>{
        const updatedOTPValues = [
            ...otpValues
        ];
        updatedOTPValues[activeInput] = str[0] || "";
        setOTPValues(updatedOTPValues);
    }, [
        activeInput,
        otpValues
    ]);
    // Focus `inputIndex` input
    const focusInput = (0,react.useCallback)((inputIndex)=>{
        const selectedIndex = Math.max(Math.min(length - 1, inputIndex), 0);
        setActiveInput(selectedIndex);
    }, [
        length
    ]);
    const focusPrevInput = (0,react.useCallback)(()=>{
        focusInput(activeInput - 1);
    }, [
        activeInput,
        focusInput
    ]);
    const focusNextInput = (0,react.useCallback)(()=>{
        focusInput(activeInput + 1);
    }, [
        activeInput,
        focusInput
    ]);
    // Handle onFocus input
    const handleOnFocus = (0,react.useCallback)((index)=>()=>{
            focusInput(index);
        }, [
        focusInput
    ]);
    // Handle onChange value for each input
    const handleOnChange = (0,react.useCallback)((e)=>{
        const val = getRightValue(e.currentTarget.value);
        if (!val) {
            e.preventDefault();
            return;
        }
        changeCodeAtFocus(val);
        focusNextInput();
    }, [
        changeCodeAtFocus,
        focusNextInput,
        getRightValue
    ]);
    // Handle onBlur input
    const onBlur = (0,react.useCallback)(()=>{
        setActiveInput(-1);
    }, []);
    // Handle onKeyDown input
    const handleOnKeyDown = (0,react.useCallback)((e)=>{
        const pressedKey = e.key;
        switch(pressedKey){
            case "Backspace":
            case "Delete":
                {
                    e.preventDefault();
                    if (otpValues[activeInput]) {
                        changeCodeAtFocus("");
                    } else {
                        focusPrevInput();
                    }
                    break;
                }
            case "ArrowLeft":
                {
                    e.preventDefault();
                    focusPrevInput();
                    break;
                }
            case "ArrowRight":
                {
                    e.preventDefault();
                    focusNextInput();
                    break;
                }
            default:
                {
                    if (pressedKey.match(/^[^a-zA-Z0-9]$/)) {
                        e.preventDefault();
                    }
                    break;
                }
        }
    }, [
        activeInput,
        changeCodeAtFocus,
        focusNextInput,
        focusPrevInput,
        otpValues
    ]);
    const handleOnPaste = (0,react.useCallback)((e)=>{
        e.preventDefault();
        const pastedData = e.clipboardData.getData("text/plain").trim().slice(0, length - activeInput).split("");
        if (pastedData) {
            let nextFocusIndex = 0;
            const updatedOTPValues = [
                ...otpValues
            ];
            updatedOTPValues.forEach((val, index)=>{
                if (index >= activeInput) {
                    const changedValue = getRightValue(pastedData.shift() || val);
                    if (changedValue) {
                        updatedOTPValues[index] = changedValue;
                        nextFocusIndex = index;
                    }
                }
            });
            setOTPValues(updatedOTPValues);
            setActiveInput(Math.min(nextFocusIndex + 1, length - 1));
        }
    }, [
        activeInput,
        getRightValue,
        length,
        otpValues
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (OTPInput_module_default()).Wrapper,
        children: Array(length).fill("").map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(single_otp_input_SingleOTPInput, {
                focus: activeInput === index,
                value: otpValues && otpValues[index],
                onFocus: handleOnFocus(index),
                onChange: handleOnChange,
                onKeyDown: handleOnKeyDown,
                onBlur: onBlur,
                onPaste: handleOnPaste
            }, "SingleInput-".concat(index)))
    });
};
/* harmony default export */ var otp_input_OTPInput = (/*#__PURE__*/(0,react.memo)(OTPInput));

;// CONCATENATED MODULE: ./src/components/otp-input/index.tsx


// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(92928);
// EXTERNAL MODULE: ./src/components/two-factors/TwoFactors.module.scss
var TwoFactors_module = __webpack_require__(1018);
var TwoFactors_module_default = /*#__PURE__*/__webpack_require__.n(TwoFactors_module);
;// CONCATENATED MODULE: ./src/components/two-factors/TwoFactors.tsx













const TwoFactors = (param)=>{
    let { qrCode , token , onBack  } = param;
    const router = (0,next_router.useRouter)();
    const [form] = es_form/* default.useForm */.Z.useForm();
    const { t  } = (0,useTranslation/* default */.Z)("two-factors");
    const setAccessTokenCookie = useAccessTokenCookie();
    const [loginTwoFactors, { loading , error  }] = (0,useMutation/* useMutation */.D)(graphql_login/* LOGIN_TWO_FACTORS */.AU, {
        onError: ()=>{},
        onCompleted: (res)=>{
            form.resetFields();
            const { redirect , tokens  } = res.loginTwoFactors;
            if (redirect) {
                lib_redirectToClient(redirect, tokens.access_token);
            } else {
                setAccessTokenCookie(tokens.access_token, tokens.expires_in);
            }
        }
    });
    const handleSubmitLoginTwoFactors = (values)=>{
        loginTwoFactors({
            variables: {
                token,
                code: values.code,
                client: form.getFieldValue("client")
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error_feedback/* default */.Z, {
                asAlert: true,
                error: error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
                form: form,
                onFinish: handleSubmitLoginTwoFactors,
                initialValues: {
                    client: router.query.client || "auth"
                },
                children: [
                    qrCode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* default.Paragraph */.Z.Paragraph, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                    i18nKey: "two-factors:qrcode",
                                    components: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {}, "bold")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* default.Paragraph */.Z.Paragraph, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                    i18nKey: "two-factors:manual",
                                    components: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            rel: "noreferrer",
                                            className: (TwoFactors_module_default()).Link,
                                            href: "https://www.opiquad.it/area-clienti/accesso-portali-opiquad/"
                                        }, "link")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (TwoFactors_module_default()).QrCode,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    width: 200,
                                    height: 200,
                                    alt: "Qr Code",
                                    src: qrCode
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* default.Paragraph */.Z.Paragraph, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                            i18nKey: "two-factors:recovery",
                            components: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:support-hub@opiquad.it"
                                }, "link")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        name: "client",
                        hidden: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        name: "code",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(otp_input_OTPInput, {
                            length: 6
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                        block: true,
                        size: "large",
                        type: "primary",
                        htmlType: "submit",
                        loading: loading,
                        children: t("confirm")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                        block: true,
                        type: "link",
                        className: "mt:2",
                        onClick: ()=>{
                            onBack();
                            form.resetFields();
                        },
                        children: t("back-to-login")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var two_factors_TwoFactors = (TwoFactors);

;// CONCATENATED MODULE: ./src/pages/index.tsx












const Home = ()=>{
    const router = (0,next_router.useRouter)();
    const setAccessTokenCookie = useAccessTokenCookie();
    const [loginData, setLoginData] = (0,react.useState)(null);
    const [loginFromCookie, { loading , data  }] = (0,useMutation/* useMutation */.D)(graphql_login/* LOGIN_FROM_COOKIE */.n$, {
        onError: ()=>{},
        variables: {
            client: router.query.client || "auth"
        },
        onCompleted: (res)=>{
            const { redirect , tokens  } = res.loginFromCookie;
            if (redirect) {
                lib_redirectToClient(redirect, tokens.access_token);
            } else {
                setAccessTokenCookie(tokens.access_token, tokens.expires_in);
            }
        }
    });
    (0,react.useEffect)(()=>{
        if (router.isReady && !("logout" in router.query) && (0,lib.hasCookie)("user_id")) {
            loginFromCookie();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router
    ]);
    if (loading || (data === null || data === void 0 ? void 0 : data.loginFromCookie)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loader_Loader, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(document_title/* default */.Z, {
                title: "Login"
            }),
            !loginData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(login_Login, {
                onLoginCompleted: (token, qrCode)=>setLoginData({
                        token,
                        qrCode
                    })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(two_factors_TwoFactors, {
                ...loginData,
                onBack: ()=>setLoginData(null)
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 9860:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Alert":"rdsW9a","General":"E2kqIV","Ul":"e9aapo"};

/***/ }),

/***/ 28719:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"pqyqDB","Fullscreen":"_Z1__K"};

/***/ }),

/***/ 35209:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"BrbK0W"};

/***/ }),

/***/ 70221:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Input":"_8mc87r"};

/***/ }),

/***/ 1018:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"QrCode":"ccc8Cs","Link":"_h__2x"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2814,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);